document.addEventListener('DOMContentLoaded', function() {
    function initQuantityButtons() {
        const quantityInputs = document.querySelectorAll('.quantity input[type=number]');

        quantityInputs.forEach(input => {
            if (input.closest('.custom-quantity-wrapper')) {
                return;
            }

            const wrapper = document.createElement('div');
            wrapper.className = 'custom-quantity-wrapper';

            const minusButton = document.createElement('button');
            minusButton.className = 'quantity-minus';
            minusButton.type = 'button';
            minusButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM7 11H17V13H7V11Z"></path></svg>';

            const plusButton = document.createElement('button');
            plusButton.className = 'quantity-plus';
            plusButton.type = 'button';
            plusButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M11 11V7H13V11H17V13H13V17H11V13H7V11H11ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"></path></svg>';

            input.parentNode.insertBefore(wrapper, input);
            wrapper.appendChild(minusButton);
            wrapper.appendChild(input);
            wrapper.appendChild(plusButton);

            minusButton.addEventListener('click', () => {
                if (input.value > parseInt(input.min)) {
                    input.value--;
                    input.dispatchEvent(new Event('change'));
                }
            });

            plusButton.addEventListener('click', () => {
                if (input.value < parseInt(input.max)) {
                    input.value++;
                    input.dispatchEvent(new Event('change'));
                }
            });

            input.addEventListener('change', () => {
                const form = input.closest('.woocommerce-cart-form');
                if (form) {
                    form.querySelector('button[name="update_cart"]').disabled = false;
                    form.querySelector('button[name="update_cart"]').click();
                }
            });
        });
    }

    function refreshMiniCart() {
        jQuery(document.body).trigger('wc_fragment_refresh');
    }

    initQuantityButtons();

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                initQuantityButtons();
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    document.body.addEventListener('wc_fragments_refreshed', function() {
        initQuantityButtons();
    });

    document.body.addEventListener('updated_wc_div', function() {
        initQuantityButtons();
        refreshMiniCart();
    });

    jQuery(document).ajaxComplete(function(event, xhr, settings) {
        if (settings.url.includes('wc-ajax=update_order_review') || settings.url.includes('wc-ajax=get_refreshed_fragments')) {
            initQuantityButtons();
        }
    });
});
